if (!customElements.get("custom-reviews-new")) {
  customElements.define(
    "custom-reviews-new",
    class CustomReviewsNew extends HTMLElement {
      constructor() {
        super();
        var url_string = window.location.href;
        var url = new URL(url_string);
        var maintitle = $('main-product-mockup').data("maintitle"); 

        this.jsonarr = [];

        if(url.searchParams.has('make')){
          this.make = url.searchParams.get("make");
        }else{
          this.make = '';
        }
        if(url.searchParams.has('model')){
          this.model = url.searchParams.get("model");
        }else{
          this.model = '';
        }
        if(url.searchParams.has('year')){
          this.year = url.searchParams.get("year");
        }else{
          this.year = '';
        } 
        this.loaddata();
      }
      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
      loaddata() {
        var csvurl = $(this).data("csvurl");

        var this3 = this;

        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            var csvData = data;
            let word_array = $.csv.toArrays(csvData);

            for (let index = 1; index < word_array.length; index++) {
              var ob = {};
              ob["category"] = word_array[index][0];
              ob["ratinglabel1"] = word_array[index][1];
              ob["rating1"] = word_array[index][2];
              ob["ratinglabel2"] = word_array[index][3];
              ob["rating2"] = word_array[index][4];
              ob["ratinglabel3"] = word_array[index][5];
              ob["rating3"] = word_array[index][6];
              ob["heading"] = word_array[index][7]
                .replace("$make", this3.make)
                .replace("$model", this3.model);
              ob["content"] = word_array[index][8]
                .replace("$make", this3.make)
                .replace("$model", this3.model);
              ob["author"] = word_array[index][9]
                .replace("$make", this3.make)
                .replace("$model", this3.model);
              ob["title"] = word_array[index][10]
                .replace("$make", this3.make)
                .replace("$model", this3.model);
              ob["verified"] = word_array[index][11]
                .replace("$make", this3.make)
                .replace("$model", this3.model);
              this3.jsonarr.push(ob);
            }

            setDataInPage(this3.jsonarr, 1);
            var length = Math.ceil(this3.jsonarr.length / 3);
            generatePagination(1, length);
          },
        });

        function setDataInPage(data, currentpage) {
          const itemsPerPage = 3;
          const startIndex = (currentpage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const paginatedItems = data.slice(startIndex, endIndex);

          var str = "";
 
          paginatedItems.forEach((item) => {
            var rating1 = "";
            var r1count = parseInt(item.rating1) || 5;
            for (var i = 0; i < r1count; i++) {
              rating1 =
                rating1 +
                ` <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                <path d="M17.1 7.60999L15.75 8.78L14.03 10.27L13.43 10.79L14.03 13.36L14.53 15.51C14.64 15.99 14.4 16.42 14.03 16.61C13.74 16.77 13.37 16.79 13.04 16.59L12.31 16.15L10.59 15.11L8.88999 14.08L8.86997 14.09L7.14996 15.13L5.43997 16.16L4.73996 16.58C4.39996 16.79 4.01997 16.76 3.71997 16.59C3.36997 16.39 3.13997 15.97 3.24997 15.5L3.71997 13.48L4.34998 10.78L3.71997 10.23L1.99997 8.73999L0.679963 7.60001C0.00996307 7.02001 0.36997 5.92001 1.24997 5.85001L1.99997 5.79001L3.71997 5.64001L5.43997 5.48999L6.07996 5.44L7.14996 2.92001L7.96997 0.98999C8.13997 0.58999 8.50997 0.390005 8.86997 0.380005C9.24997 0.380005 9.63997 0.57999 9.80997 0.98999L10.59 2.82999L11.7 5.45001L12.31 5.5L14.03 5.64999L15.75 5.79001L16.53 5.85999C17.41 5.92999 17.77 7.02999 17.1 7.60999Z" fill="#FED927"></path>
                </svg>`;
            }
            var rating2 = "";
            var r2count = parseInt(item.rating2) || 5;
            for (var i = 0; i < r2count; i++) {
              rating2 =
                rating2 +
                ` <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                <path d="M17.1 7.60999L15.75 8.78L14.03 10.27L13.43 10.79L14.03 13.36L14.53 15.51C14.64 15.99 14.4 16.42 14.03 16.61C13.74 16.77 13.37 16.79 13.04 16.59L12.31 16.15L10.59 15.11L8.88999 14.08L8.86997 14.09L7.14996 15.13L5.43997 16.16L4.73996 16.58C4.39996 16.79 4.01997 16.76 3.71997 16.59C3.36997 16.39 3.13997 15.97 3.24997 15.5L3.71997 13.48L4.34998 10.78L3.71997 10.23L1.99997 8.73999L0.679963 7.60001C0.00996307 7.02001 0.36997 5.92001 1.24997 5.85001L1.99997 5.79001L3.71997 5.64001L5.43997 5.48999L6.07996 5.44L7.14996 2.92001L7.96997 0.98999C8.13997 0.58999 8.50997 0.390005 8.86997 0.380005C9.24997 0.380005 9.63997 0.57999 9.80997 0.98999L10.59 2.82999L11.7 5.45001L12.31 5.5L14.03 5.64999L15.75 5.79001L16.53 5.85999C17.41 5.92999 17.77 7.02999 17.1 7.60999Z" fill="#FED927"></path>
                </svg>`;
            }
            var rating3 = "";
            var r3count = parseInt(item.rating3) || 5;
            for (var i = 0; i < r3count; i++) {
              rating3 =
                rating3 +
                ` <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                <path d="M17.1 7.60999L15.75 8.78L14.03 10.27L13.43 10.79L14.03 13.36L14.53 15.51C14.64 15.99 14.4 16.42 14.03 16.61C13.74 16.77 13.37 16.79 13.04 16.59L12.31 16.15L10.59 15.11L8.88999 14.08L8.86997 14.09L7.14996 15.13L5.43997 16.16L4.73996 16.58C4.39996 16.79 4.01997 16.76 3.71997 16.59C3.36997 16.39 3.13997 15.97 3.24997 15.5L3.71997 13.48L4.34998 10.78L3.71997 10.23L1.99997 8.73999L0.679963 7.60001C0.00996307 7.02001 0.36997 5.92001 1.24997 5.85001L1.99997 5.79001L3.71997 5.64001L5.43997 5.48999L6.07996 5.44L7.14996 2.92001L7.96997 0.98999C8.13997 0.58999 8.50997 0.390005 8.86997 0.380005C9.24997 0.380005 9.63997 0.57999 9.80997 0.98999L10.59 2.82999L11.7 5.45001L12.31 5.5L14.03 5.64999L15.75 5.79001L16.53 5.85999C17.41 5.92999 17.77 7.02999 17.1 7.60999Z" fill="#FED927"></path>
                </svg>`;
            }
            str =
              str +
              `<div class="custom-reviews-main-block" >
              <div class="custom-review-star-block" > 
                  <div class="custom-review-star-wrapper margin-top-15 margin-top-mob-10" > 
                      <div class="custom-block-star-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >
                        ${item.ratinglabel1}
                      </div>
                      <div class="custom-block-star margin-top-3" >
                        ${rating1} 
                      </div> 
                  </div> 
                  <div class="custom-review-star-wrapper margin-top-15 margin-top-mob-10" > 
                      <div class="custom-block-star-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >
                         ${item.ratinglabel2}
                      </div> 
                      <div class="custom-block-star margin-top-3" >
                         ${rating2} 
                      </div> 
                  </div> 
                  <div class="custom-review-star-wrapper margin-top-15 margin-top-mob-10" > 
                      <div class="custom-block-star-label font-size-14 font-size-mob-12 font-weight-600" style="color:#4d4d4d;" >
                        ${item.ratinglabel3}
                      </div> 
                      <div class="custom-block-star margin-top-3" >  
                         ${rating3} 
                      </div> 
                  </div> 
              </div>
              <div class="custom-review-content-container padding-left-40 margin-left-26 padding-left-mob-0 margin-left-mob-0 padding-top-mob-15 margin-top-mob-15" >               
                  <div class="custom-review-heading font-size-20 font-size-mob-17 font-weight-600" style="color:#4d4d4d;" >
                    ${item.heading}
                  </div> 
                  <div class="custom-review-content font-size-14 font-size-mob-14 font-weight-400" style="color:#4d4d4d;" >
                    ${item.content}
                   </div> 
                  <div class="custom-reviews-info-block" >
                  <div class="custom-reviews-info" > 
                      <div class="custom-review-author-name font-size-15 font-size-mob-14 font-weight-600" style="color:#4d4d4d;" >
                        <p>${item.author}</p>
                      </div> 
                      <div class="custom-reviews-product-info margin-top-5 font-size-15 font-size-mob-14 font-weight-400" style="color:#4d4d4d;" >
                        ${item.title}
                      </div> 
                  </div> 
                    <div class="custom-reviews-product-verified desktop-main margin-top-5 font-size-16 font-size-mob-14 font-weight-500" style="color:#dd1d1d;" >
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 23" fill="none">
                        <g clip-path="url(#clip0_2318_7494)">
                        <path d="M19.4285 12.6492V19.5492C19.4285 20.1592 19.1877 20.7442 18.7591 21.1756C18.3304 21.6069 17.749 21.8492 17.1428 21.8492H3.42854C2.82233 21.8492 2.24095 21.6069 1.81229 21.1756C1.38364 20.7442 1.14282 20.1592 1.14282 19.5492V5.74922C1.14282 5.13922 1.38364 4.55421 1.81229 4.12287C2.24095 3.69154 2.82233 3.44922 3.42854 3.44922H13.7143" stroke="#dd1d1d" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M24 0.296964L13.328 15.8212C13.1015 16.1333 12.7613 16.1953 12.4774 15.9463C12.4203 15.8843 12.4203 15.8843 12.363 15.8212L5.5 7L5.85242 6.09883L12.7681 11.6393L23.7166 0.0471009C23.773 -0.0157003 23.8867 -0.0157003 23.9431 0.0471009C24 0.108829 24 0.233894 24 0.296964Z" fill="#dd1d1d"></path>
                        </g>
                        <defs>
                        <clipPath id="clip0_2318_7494">
                        <rect width="24" height="23" fill="white"></rect>
                        </clipPath>
                        </defs>
                      </svg> 
                      ${item.verified}
                    </div> 
                </div>
              </div>
            </div>`;
          });
          $(this3).find(".custom-reviews-container-wrapper").html(str);
        }

        function generatePagination(current, total) {
          var pagination = $(this3).find(".custom-pagination-new");
          pagination.empty();

          if (total <= 1) {
            return;
          }

          if (current > 1) {
            pagination.append(`<a
            data-page="${current - 1}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <g clip-path="url(#clip0_24_3)">
              <path d="M7.6386 0.291287C7.77852 0.431239 7.85712 0.621048 7.85712 0.818929C7.85712 1.01683 7.77852 1.20662 7.6386 1.3466L3.94431 5.04088L7.6386 8.7352C7.77455 8.87596 7.84978 9.06448 7.84808 9.26016C7.84638 9.45585 7.76789 9.64303 7.62951 9.78141C7.49114 9.91978 7.30395 9.99827 7.10827 9.99997C6.91258 10.0017 6.72406 9.92645 6.5833 9.7905L2.36135 5.56855C2.22143 5.4286 2.14283 5.23879 2.14283 5.04088C2.14283 4.843 2.22143 4.65319 2.36135 4.51324L6.5833 0.291287C6.72326 0.151382 6.91305 0.0727626 7.11095 0.0727626C7.30885 0.0727626 7.49865 0.151382 7.6386 0.291287Z" fill="#4D4D4D"/>
              </g>
              <defs>
              <clipPath id="clip0_24_3">
              <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 -1 10 10)"/>
              </clipPath>
              </defs>
            </svg>
            Previous</a
          >`);
          } else {
            pagination.append(`<a style="color:#b0b0b0;border-color:#b0b0b0;cursor:auto;">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <g clip-path="url(#clip0_24_3)">
                <path d="M7.6386 0.291287C7.77852 0.431239 7.85712 0.621048 7.85712 0.818929C7.85712 1.01683 7.77852 1.20662 7.6386 1.3466L3.94431 5.04088L7.6386 8.7352C7.77455 8.87596 7.84978 9.06448 7.84808 9.26016C7.84638 9.45585 7.76789 9.64303 7.62951 9.78141C7.49114 9.91978 7.30395 9.99827 7.10827 9.99997C6.91258 10.0017 6.72406 9.92645 6.5833 9.7905L2.36135 5.56855C2.22143 5.4286 2.14283 5.23879 2.14283 5.04088C2.14283 4.843 2.22143 4.65319 2.36135 4.51324L6.5833 0.291287C6.72326 0.151382 6.91305 0.0727626 7.11095 0.0727626C7.30885 0.0727626 7.49865 0.151382 7.6386 0.291287Z" fill="#4D4D4D"/>
              </g>
              <defs>
              <clipPath id="clip0_24_3">
              <rect width="10" height="10" fill="white" transform="matrix(-1 0 0 -1 10 10)"/>
              </clipPath>
              </defs>
            </svg>
            Previous</a>`);
          }
          if (current == 1) {
            pagination.append(`<span class="current">1</span>`);
          } else {
            pagination.append(`<a data-page="1">1</a>`);
          }
          if (current > 2) {
            pagination.append("<span>...</span>");
          }

          if (current != 1 && current != total) {
            pagination.append(`<span class="current">${current}</span>`);
          }

          if (current < total - 1) {
            pagination.append("<span>...</span>");
          }
          if (current == total) {
            pagination.append(`<span class="current">${total}</span>`);
          } else {
            pagination.append(`<a data-page="${total}">${total}</a>`);
          }
          if (current < total) {
            pagination.append(`<a data-page="${current + 1}">
              Next  
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 24 42"
                fill="none">
                <path d="M0.917757 40.7766C0.330118 40.1888 -5.0137e-07 39.3916 -5.0137e-07 38.5605C-5.0137e-07 37.7293 0.330118 36.9322 0.917757 36.3443L16.4338 20.8283L0.917757 5.31218C0.346771 4.72099 0.0308254 3.9292 0.0379672 3.10732C0.0451091 2.28545 0.374767 1.49926 0.95594 0.918091C1.53711 0.336917 2.3233 0.00726254 3.14517 0.000120696C3.96705 -0.00702115 4.75884 0.308925 5.35003 0.879911L23.0822 18.6121C23.6699 19.1999 24 19.9971 24 20.8283C24 21.6594 23.6699 22.4566 23.0822 23.0444L5.35003 40.7766C4.76221 41.3642 3.96507 41.6944 3.13389 41.6944C2.30272 41.6944 1.50557 41.3642 0.917757 40.7766Z" fill="#4d4d4d"></path>
              </svg> 
              </a>`);
          } else {
            pagination.append(`<a 
                style="color:#b0b0b0;border-color:#b0b0b0;cursor:auto;" 
            > 
              Next <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 24 42"
                fill="none"
              >
                <path d="M0.917757 40.7766C0.330118 40.1888 -5.0137e-07 39.3916 -5.0137e-07 38.5605C-5.0137e-07 37.7293 0.330118 36.9322 0.917757 36.3443L16.4338 20.8283L0.917757 5.31218C0.346771 4.72099 0.0308254 3.9292 0.0379672 3.10732C0.0451091 2.28545 0.374767 1.49926 0.95594 0.918091C1.53711 0.336917 2.3233 0.00726254 3.14517 0.000120696C3.96705 -0.00702115 4.75884 0.308925 5.35003 0.879911L23.0822 18.6121C23.6699 19.1999 24 19.9971 24 20.8283C24 21.6594 23.6699 22.4566 23.0822 23.0444L5.35003 40.7766C4.76221 41.3642 3.96507 41.6944 3.13389 41.6944C2.30272 41.6944 1.50557 41.3642 0.917757 40.7766Z" fill="#4d4d4d"></path>
              </svg>
              </a>`);
          }
          $.fn.hasAttr = function (name) {
            return this.attr(name) !== undefined;
          };
          $(this3)
            .find(".custom-pagination-new")
            .find("a")
            .click(function (e) {
              e.preventDefault();
              e.stopPropagation();
              if ($(this).hasAttr("data-page")) {
                setDataInPage(this3.jsonarr, $(this).data("page"));
                const total = Math.ceil(this3.jsonarr.length / 3);
                generatePagination($(this).data("page"), total);
              }
            });
        }
      }
    }
  );
}

function ratingStar(star) {
  star.click(function () {
    var stars = $(this).parents(".ratingW").find("li");
    stars.removeClass("on");
    var thisIndex = $(this).parents("li").index();
    for (var i = 0; i <= thisIndex; i++) {
      stars.eq(i).addClass("on");
    }
    putScoreNow(thisIndex + 1);
    var val = thisIndex + 1 + "";
    $(this).parents(".star-rating").find("input").attr("value", val);
  });
}

function putScoreNow(i) {
  $(".scoreNow").html(i);
}

$(function () {
  if ($(".ratingW").length > 0) {
    ratingStar($(".ratingW li a"));
  }
  $(".review-popup-opener").click(function () {
    $(".modal-raw").show();
  });
  $(".close").click(function () {
    $(".modal-raw").hide();
  });
});
